import { useTranslation } from 'react-i18next';
import { useGetPendingReports } from '@/query/queries/reporting/useGetPendingReports';
import { ReportingCard } from '../card';
import s from './index.module.scss';

export const PendingDocuments = () => {
  const { data: reports } = useGetPendingReports();
  const { t } = useTranslation('reporting');

  if (!reports?.length) return null;

  return (
    <div className={s.wrapper}>
      <div className="f-body-regular">{t('reporting_page.pending_docs')}</div>
      <div className={s.reports}>
        {reports.map(report => (
          <ReportingCard key={report.id} report={report} />
        ))}
      </div>
    </div>
  );
};
